export const config = {
 // url: 'http://localhost:2543',
  url:'https://api.nanosealco.com',
  //fronturl:'http://localhost:3000'
  fronturl: 'https://api.nanosealco.com'

}
export const headersinfo = {
  'Access-Control-Allow-Origin': '*',
  'Content-Type': `multipart/form-data`,
}
